import { render, staticRenderFns } from "./NavigationItemEditorialV2.vue?vue&type=template&id=91b13234&"
import script from "./NavigationItemEditorialV2.vue?vue&type=script&lang=js&"
export * from "./NavigationItemEditorialV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports